var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"readonly-field"},[_c('label',[_vm._v(_vm._s(_vm.title))]),_c('label',[_vm._v(_vm._s(_vm.value || " "))])])}
var staticRenderFns = []

export { render, staticRenderFns }